/**
 * @file 日志模块
 * @author xujipeng@baidu.com
 * @description 设置页面基础属性
 */

/* global swan getApp */

export function setPageInfoMenu(config) {
  let reqInfo = Object.assign({}, {
    title: '律临法律服务',
    keywords: '律临法律服务',
    description: '律临法律服务, 百度找律师, 问律师, 百度问律师, 百度律临是一个专业权威的法律综合服务平台，拥有海量专业法律内容，万名认证律师随时在线提供个性化法律服务。'
  }, config);
  try {
    document.title = reqInfo.title;
    const meta = document.getElementsByTagName('meta');
    meta.description.setAttribute('content', reqInfo.description);
    meta.keywords.setAttribute('content', reqInfo.keywords);
  } catch (error) {}
}